import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { RootConstants, ISearchCategory } from '@apps/root/root.constants';

import { GlobalSearchService, GlobalSearchContext } from '../service';
import { searchResultAnimations, PopupMenuAnimationState } from './search-result.animations';

@Component({
    selector: 'aa-search-result',
    templateUrl: './search-result.component.html',
    styleUrls: [
        './search-result.component.scss'
    ],
    animations: [
        searchResultAnimations.showSearchResult
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchResultComponent implements OnInit
{
    public isPanelShown: Observable<boolean> = of(false);
    public categories: Map<string, ISearchCategory> = RootConstants.SearchConstants.categories;
    public animationState: PopupMenuAnimationState = 'hide';
    public height: number;

    constructor (
        private globalSearchService: GlobalSearchService
    )
    {
    }

    ngOnInit ()
    {
        this.height = 280;
        this.animationState = 'hide';

        this.isPanelShown = this.globalSearchService.contextor
            .pipe(
                map((ctxt: GlobalSearchContext) =>
                    ctxt.isPanelShown
                )
            );
    }
}
